import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";
import { TaxCodeBus } from "./TaxCodeBus";
import { CommonValues } from "../static/CommonValues";

export class QILineItemBus extends BaseBus {
    constructor(busObj: QILineItemBus = null) {
        super(busObj);
        if (CommonFunctions.hasValue(busObj)) {
            this.insertDt = DateFunctions.getDate(busObj.insertDt);
            this.updateDt = DateFunctions.getDate(busObj.updateDt);
        }
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.isPrintable = true;
        if (other) {
            this.inventoryLocationId = other.inventoryLocationId;
        }
        else {
            this.inventoryLocationId = null;

        }
    }

    changeInventoryItem(data: v_InventoryBus) {
        this.inventoryNumber = data.number;
        this.lineDesc = data.inventoryDesc;
        this.fullDescription = data.fullDescription;
        //this.quantity = 1;
        this.cost = data.currentCost;
        this.markup = 0;
        this.markupCost = 0;
        this.price = 0;
        this.isPart = data.isPart;
        this.hourlyRate = 0;
        this.overheadRate = 0;
        this.overheadPercent = 0;
        this.tax = 0;
        this.ratio = 0;
        this.inventoryBillingCodeId = data.inventoryId;
        this.inventoryLocationId = null;
        this.billingTypeId = data.billingTypeId;
        this.isConsumable = data.inventorySubCategoryId === CommonValues.InventorySubCategory_Consumables ? true : false;
        this.isRefrigerant = data.isRefrigerant;
        this.isTool = data.isTool;
        this.isNonInvPart = data.isNonInvPart;
    }

    setInventoryLine(data: QILineItemBus, checkQtyAndAmount: boolean = false) {
        this.inventoryNumber = data.inventoryNumber;
        this.lineDesc = data.lineDesc;
        this.fullDescription = data.fullDescription;
        this.quantity = data.quantity;
        //if (checkQtyAndAmount && this.quantity > 0 && this.quantity !== data.quantity) {
        //    this.amount = CommonFunctions.RoundToPrecision((this.quantity * data.price), 2);
        //}
        //else {
        //    this.quantity = data.quantity;
        //}
        this.cost = data.cost;
        this.markup = data.markup;
        this.markupPercent = data.markup * 100; 
        this.markupCost = data.markupCost;
        this.price = data.price;
        this.isPart = data.isPart;
        this.hourlyRate = data.hourlyRate;
        this.overheadRate = data.overheadRate;
        this.overheadPercent = data.overheadPercent;
        this.tax = data.tax;
        this.isTaxable = data.isTaxable;
        this.inventoryBillingCodeId = data.inventoryBillingCodeId;
        if (!this.isPart) {
            this.inventoryLocationId = null;
        }
        this.billingTypeId = data.billingTypeId;
        this.isConsumable = data.isConsumable;
        this.isRefrigerant = data.isRefrigerant;
        this.isTool = data.isTool;
        this.isNonInvPart = data.isNonInvPart;
//        this.avalaraTaxCalculated = data.avalaraTaxCalculated;
        if (data.inventoryBillingCodeId == CommonValues.BillingCode_RET || data.inventoryBillingCodeId == CommonValues.BillingCode_SUBRET) {
            this.cost = 0;
            this.quantity = -1;
            this.markup = 0;
            this.markupCost = 0;
            this.price = 0;
        }
        //else if (!CommonFunctions.hasGuidValue(data.inventoryLocationId) && data.isPart || data.billingTypeId == CommonValues.BillingType_NonInventoryPart) {
        //    this.inventoryLocationId = CommonValues.InventoryLocation_StagingWarehouse;
        //}
        //this.billingTypeName = 
        //this.isLabor = 

    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    //    this.markup = this.markupPercent/100
    }
    calculateTotals() {
        if(this.billingTypeId !== CommonValues.BillingType_Subtotal) {
            //let cost: number = CommonFunctions.RoundToPrecision(this.cost, 3);
            let totalCost: number = this.quantity * CommonFunctions.Round(this.cost);
            this.totalCost = CommonFunctions.RoundToPrecision(totalCost, 2)
            this.amount = CommonFunctions.RoundToPrecision((this.quantity * this.price), 2);
            this.markup = CommonFunctions.RoundToPrecision(this.markup, 4);
        }

    }
    calculateTotalCost() {
        if (this.billingTypeId !== CommonValues.BillingType_Subtotal) {
            let totalCost: number = this.quantity * CommonFunctions.Round(this.cost);
            this.totalCost = CommonFunctions.RoundToPrecision(totalCost, 2)
        }

    }
    setValuesToNull() {
        this.sortOrder = null;
        this.quantity = null;
        this.cost = null;
        this.markup = null;
        this.price = null;
        this.isTaxable = null;
        this.isPrintable = null;
        this.lineDesc = null;
        this.inventoryNumber = null;
        this.isPart = null;
        this.hourlyRate = null;
        this.overheadRate = null;
        this.overheadPercent = null;
        this.amount = null;
        this.markupCost = null;
        this.fullDescription = null;
        this.tax = null;
        this.inventoryBillingCodeId = null;
        this.inventoryLocationId = null;
        this.billingTypeId = null;
        this.personId = null;
        this.totalCost = null;
        this.ratio = null;
        this.dragging = null;
        this.isLabor = null;
        this.insertDt = null;
        this.insertUserId = null;
        this.updateDt = null;
        this.updateUserId = null;
        this.isConsumable = null;
        this.isRefrigerant = null;
        this.avalaraTaxCalculated = null;
        this.isNonInvPart = null;
    }
    get markupPercent(): number {
        return this.markup * 100;
    }
    set markupPercent(value: number) {
        this.markup = CommonFunctions.RoundToPrecision(value / 100, 4);
    }
    get orderValue(): number {
        return this.sortOrder;
    }
    set orderValue(value: number) {
        this.sortOrder = value;
    }
    public companyId: any;
    public cost: number;
    public markup: number;
  //  public markupPercent: number;
    public price: number;
    public isTaxable: boolean;
    public isRetailTax: boolean;
    public isPrintable: boolean;
    public dragging: boolean;
    public lineDesc: string;
    public inventoryNumber: string;
    public isPart: boolean;
    public quantity: number;
    public hourlyRate: number;
    public overheadRate: number;
    public overheadPercent: number;
    public amount: number;
    public markupCost: number;
    public fullDescription: string;
    public tax: number;
    public ratio: number;
    public inventoryBillingCodeId: any;
    public inventoryLocationId: any;
    public billingTypeId: any;
    public personId: any;
    public totalCost: number;
    public isLabor: boolean;
    public sndZeroSpOhEm: boolean;
    public insertDt: Date;
    public insertUserId: any;
    public updateDt: Date;
    public updateUserId: any;
    public sortOrder: number;
    public resource: string;
    public isConsumable: boolean;
    public isTool: boolean;
    public isRefrigerant: boolean;
    public isNonInvPart: boolean;
    public avalaraTaxCalculated: number;
    public locationQuantity: number;
    public allQuantity: number;
    public avalaraTaxTypeId: string;
}
